// extracted by mini-css-extract-plugin
export default {"container":"end-slide_container__psOJ1","link":"end-slide_link__F1p3r"};